mutation verifyMfaPhoneNumber($code: String!) {
  verifyMfaPhoneNumber(code: $code)
}
